import { FunctionalHOC } from '../renderer';
import { checkAndResolve } from '../utils/resolvers-helper';

export const withResolvedBudgetProps: FunctionalHOC = (Component) => {
  return (props) => {
    const resolvedProps = checkAndResolve({ ...props }, {}, {} as typeof props);
    const mergedProps = {
      ...props,
      ...resolvedProps
    };

    return <Component {...mergedProps} />;
  };
};
